import React from 'react';

import PropTypes from 'prop-types';

import { ButtonWrapper } from './style';

const Button = ({ children, ...props }) => (
  <ButtonWrapper {...props}>{children}</ButtonWrapper>
);

Button.propTypes = {
  variant: PropTypes.oneOf([
    'login',
    'cta',
    'popupYes',
    'popupCancel',
    'people-buttons',
    'charger-button',
    'accept-button',
    'create-account-buttons',
    'otp',
    'changepassword',
    'changeaccountpassword',
    'sb-charger-button',
    'changesites',
    'rfid',
    'resendEmailButton',
    'login-cancel',
    'editaccountdata'
  ]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default Button;
